import React, { useContext } from "react";
import { Button, Flex, Heading, Modal } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";

interface AdminViewSelectionModalProps {
  takeToAdminApps: () => void;
  takeToHome: () => void;
}

export function AdminViewSelectionModal(props: AdminViewSelectionModalProps): JSX.Element {
  const i18n = useContext(I18nContext);

  if (!i18n) {
    throw new Error("I18nContext is not available");
  }

  const { t } = i18n;
  const { takeToAdminApps, takeToHome } = props;

  const buttonStyle = { height: "70px", padding: "16px" };

  return (
    <Modal isOpen>
      <Flex direction="vertical" gap={16} style={{ padding: "16px" }}>
        <Heading id="admin-action-popup">{t("auth.login.login-partner-base.select-to-proceed", { ns: "spaces-dash-app-partners-login" })}</Heading>
        <Button.Group>
          <Button kind="secondary" id="go-to-partner-dashboard" onClick={takeToHome} style={buttonStyle}>
            {t("auth.login.login-partner-base.go-to-partner-dashboard", { ns: "spaces-dash-app-partners-login" })}
          </Button>
          <Button onClick={takeToAdminApps} id="go-to-admin-view" style={buttonStyle}>
            {t("auth.login.login-partner-base.go-to-admin-view-text", { ns: "spaces-dash-app-partners-login" })}
          </Button>
        </Button.Group>
      </Flex>
    </Modal>
  );
}
